<template>
  <!-- Employees + date range filter. Mirrors `ServicesFilter` but with
       only the employees leg (no services). Value shape unchanged:
         { employees: Employee[], date: { start, finish } } -->
  <FilterControlGroup>
    <div class="space-y-1">
      <label class="text-xs font-medium text-gray-600 dark:text-gray-400">
        {{ $t('components.customer.list.fieldsWithDateRange.during') }}
      </label>
      <DateRangeFilter v-model="modelValue.date" />
    </div>

    <div class="space-y-1">
      <div class="flex items-center justify-between">
        <label class="text-xs font-medium text-gray-600 dark:text-gray-400">
          {{ $t('general.employees') }}
          <span v-if="modelValue.employees.length" class="text-primary-500">
            ({{ modelValue.employees.length }})
          </span>
        </label>
        <button
          v-if="modelValue.employees.length"
          type="button"
          class="text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
          @click="clearEmployees"
        >
          {{ $t('general.clear') }}
        </button>
      </div>
      <ModelMultiSelect
        :model-value="modelValue.employees"
        :items="employeeItems"
        :placeholder="$t('customer.filters.allEmployees')"
        by="idEmployee"
        @update:model-value="(v: any) => onEmployeesChange(v)"
      />
    </div>
  </FilterControlGroup>
</template>

<script setup lang="ts">
import DateRangeFilter from './DateRangeFilter.vue'
import FilterControlGroup from './FilterControlGroup.vue'
import ModelMultiSelect from './ModelMultiSelect.vue'

const modelValue = defineModel<{
  employees: any[]
  date: { start: number | null; finish: number | null }
}>({
  default: () => ({ employees: [], date: { start: null, finish: null } }),
})

const employeeStore = useEmployeeStore()

const employeeItems = computed(() =>
  ((employeeStore.all as any[]) ?? []).map((emp: any) => ({
    ...emp,
    label: emp.displayName,
  })),
)

const onEmployeesChange = (v: any[]) => {
  modelValue.value = { ...modelValue.value, employees: Array.isArray(v) ? v : [] }
}

const clearEmployees = () => {
  modelValue.value = { ...modelValue.value, employees: [] }
}
</script>
